/** Высота кнопок строки действий героя анкеты по макету, px */
export const HERO_BUTTON_HEIGHT = 36.5;

/**
 * Кольцо фокуса с клавиатуры на тёмной полосе героя: как у обычных кнопок макета —
 * штатное кольцо браузера, а не едва заметная рябь MUI
 */
export const ON_DARK_FOCUS_RING_SX = {
  '&.Mui-focusVisible': {
    outline: '1px auto -webkit-focus-ring-color',
    outlineOffset: 0
  }
} as const;

/**
 * Контурная кнопка на тёмной поверхности (герой анкеты): белая обводка 50 %,
 * белый текст, радиус пилюли, высота 36.5 как в макете. Общие кнопки не
 * перекрашиваются — стиль передаётся `sx` в месте вызова.
 */
export const ON_DARK_OUTLINED_SX = {
  height: HERO_BUTTON_HEIGHT,
  minHeight: HERO_BUTTON_HEIGHT,
  boxSizing: 'border-box',
  color: 'common.white',
  bgcolor: 'transparent',
  borderColor: 'rgba(255, 255, 255, 0.5)',
  borderRadius: 4,
  ...ON_DARK_FOCUS_RING_SX,
  '&:hover': {
    borderColor: 'common.white',
    bgcolor: 'rgba(255, 255, 255, 0.08)'
  }
} as const;

/**
 * Главная кнопка («Пригласить на кастинг») в герое: градиент макета без
 * растяжки на 200 % (в общей теме он смещается вправо), наведение — затемнение.
 */
export const HERO_PRIMARY_SX = {
  height: HERO_BUTTON_HEIGHT,
  minHeight: HERO_BUTTON_HEIGHT,
  boxSizing: 'border-box',
  boxShadow: 'none',
  ...ON_DARK_FOCUS_RING_SX,
  '&:enabled': {
    backgroundSize: 'auto',
    backgroundPosition: 'initial'
  },
  '&:enabled:hover': {
    backgroundPosition: 'initial',
    boxShadow: 'none',
    filter: 'brightness(0.95)'
  }
} as const;
